import { createSlice } from '@reduxjs/toolkit';
import { Contract } from 'modules/types/Contract';
import { fetchContracts } from './thunks';
import { ContractGroup } from '../components/helper';

export interface ContractsState {
  loading: boolean;
  contracts?: Contract[];
  group?: ContractGroup;
  totalPageCount?: number;
  error?: string;
}

const initialState: ContractsState = {
  error: undefined,
  contracts: undefined,
  group: undefined,
  loading: true,
  totalPageCount: 1,
};

export const contractsSlice = createSlice({
  name: 'contracts',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // fetch contracts
    builder.addCase(fetchContracts.pending, (state) => {
      state.loading = initialState.loading;
      state.error = initialState.error;
      state.contracts = initialState.contracts;
      state.group = initialState.group;
      state.totalPageCount = initialState.totalPageCount;
    });
    builder.addCase(fetchContracts.fulfilled, (state, action) => {
      state.contracts = action.payload.contracts;
      state.group = action.payload.group;
      state.totalPageCount = action.payload.totalPageCount;
      state.loading = false;
    });
    builder.addCase(fetchContracts.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload
        ? (action.payload as Error)?.message
        : action.error?.message;
    });
  },
});

export default contractsSlice.reducer;
